<template>
  <div class="users-container">
    <div class="action-header">
      <el-button v-permission="['user-member-add']" type="primary" @click="handleAdd">添加会员</el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%">
      <el-table-column
        prop="loginId">
        <template slot="header" slot-scope="scope">
          <div>账号</div>
          <el-input
            v-model="search.loginId"
            @change="quickSearch"
            placeholder="搜索"/>
        </template>
      </el-table-column>
      <el-table-column
        prop="trueName">
        <template slot="header" slot-scope="scope">
          <div>姓名</div>
          <el-input
            v-model="search.trueName"
            @change="quickSearch"
            placeholder="搜索"/>
        </template>
      </el-table-column>
      <el-table-column
        prop="types">
        <template slot="header" slot-scope="scope">
          <div>身份类型</div>
          <el-select v-model="search.membershipTypeId" filterable @change="quickSearch" placeholder="请选择">
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.title"
              :value="item.id">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        prop="email">
        <template slot="header" slot-scope="scope">
          <div>邮箱</div>
          <el-input
            v-model="search.email"
            @change="quickSearch"
            placeholder="搜索"/>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatDate"
        width="160"
        prop="createDate">
        <template slot="header" slot-scope="scope">
          <div>创建时间</div>
          <el-date-picker
            v-model="search.createDate"
            @change="quickSearch"
            type="date"
            placeholder="选择日期" />
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="240"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            v-permission="['user-member-edit']"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            v-permission="['user-member-role']"
            @click="handleTypeEdit(scope.$index, scope.row)">添加身份</el-button>
          <el-button
            size="mini"
            type="danger"
            v-permission="['user-member-delete']"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- create/edit modal start -->
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :title="modalTitle" center>
      <el-form :model="dialogForm" :rules="rules" ref="dialogForm" class="modal" label-width="100px">
        <el-form-item v-show="isEditMode" label="登录账号" prop="loginId">
          <el-input v-model="dialogForm.loginId" :disabled="isEditMode"/>
        </el-form-item>
        <el-form-item v-show="!isEditMode" label="登录账号" prop="mobile">
          <el-input v-model="dialogForm.mobile" :disabled="isEditMode"/>
        </el-form-item>
        <el-form-item label="选择身份" prop="membershipType">
          <el-select v-if="!isEditMode" filterable v-model="dialogForm.membershipType" :disabled="isEditMode" placeholder="请选择">
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.title"
              :value="item.id">
            </el-option>
          </el-select>
          <el-input v-else v-model="dialogForm.types" :disabled="isEditMode"/>
        </el-form-item>
        <el-form-item label="真实姓名">
          <el-input v-model="dialogForm.trueName" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="dialogForm.password" type="password" placeholder="设置密码" />
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="dialogForm.email" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('dialogForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- create/edit modal start -->

    <!-- create/edit modal start -->
    <el-dialog :visible.sync="dialogTypeVisible" :close-on-click-modal="false" title="添加会员身份" center>
      <el-form :model="dialogTypeForm" :rules="rules" ref="dialogTypeForm" class="modal" label-width="100px">
        <el-form-item label="登录账号" prop="loginId">
          <el-input v-model="dialogTypeForm.loginId" disabled/>
        </el-form-item>
        <el-form-item label="选择身份" prop="membershipType">
          <el-select v-model="dialogTypeForm.membershipType" filterable placeholder="请选择">
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.title"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTypeVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitTypeForm('dialogTypeForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- create/edit modal start -->
  </div>
</template>

<script>

  import * as moment from 'moment'
  import find from 'lodash/find'
  import { getMemberShipTypeList } from '@/api/site'
  import permission from '@/directive/permission/index.js' // 权限判断指令
  import { getUserList, addUser, updateUser, getUserById, adminDeleteUser, addMembershipTypeToMemberUser } from '@/api/user'

  const defaultForm = {}

  export default {
    name: 'UserList',
    directives: { permission },
    data() {
      return {
        search: {},
        list: [],
        totalCount: 0, // 默认数据总数
        pageSize: 20, // 每页的数据条数
        currentPage: 1, // 默认开始页面
        listQuery: {},
        listLoading: true,
        roleList: [],
        isEditMode: false,
        modalTitle: '',
        dialogForm: {},
        dialogTypeForm: {},
        dialogVisible: false,
        dialogTypeVisible: false,
        formLabelWidth: '100px',
        imageUrl: '',
        rules: {
//          mobile: [
//            { required: true, message: '请输入登录账号', trigger: 'blur' },
//            { pattern: /^1\d{10}$/, message: '目前只支持中国大陆的手机号码' }
//          ],
          membershipTypeId: [
            { required: true, message: '请选择用户身份', trigger: 'blur' }
          ]
        }
      }
    },
    created() {
      if (this.$route.query.page) {
        this.currentPage = parseInt(this.$route.query.page, 10)
      }
      this.getList()
      this.getMemberShipTypeList()
    },
    computed: {
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = val
        this.getList()
      },
      handleAdd() {
        this.dialogVisible = true
        this.isEditMode = false
        this.modalTitle = '添加用户信息'
        this.dialogForm = defaultForm
      },
      handleEdit(index, row) {
        this.getUserById(this.list[index].id)
        this.dialogVisible = true
        this.isEditMode = true
        this.modalTitle = '编辑用户信息'
      },
      handleDelete(index, row) {
        this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.deleteUser(this.list[index].id)
        }).catch(() => {
        })
      },
      // dialog form methods
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.dialogForm.mobile.length < 2) {
              this.$message({
                message: '登录账号至少需要2位字符',
                type: 'warning',
                showClose: true,
                duration: 3000
              })
              return
            }
            if(this.isEditMode) {
              this.updateUser()
            } else {
              this.addUser()
            }
          } else {
            return false
          }
        });
      },
      handleTypeEdit(index, row) {
        this.dialogTypeForm = this.list[index]
        this.dialogTypeVisible = true
      },
      submitTypeForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addMembershipTypeToMemberUser()
          } else {
            return false
          }
        });
      },
      handleCurrentChange(val) {
        this.$router.push({path: this.$route.path, query: {page: val}})
        this.currentPage = val
        this.getList()
      },
      quickSearch() {
        this.getList()
      },
      getList() {
        this.listLoading = true
        this.listQuery = {
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }
        this.listQuery = Object.assign(this.listQuery, this.search)
        getUserList(this.listQuery).then(response => {
          const data = response.data
          this.list = data.list
          this.currentPage = data.pageNum
          this.totalCount = data.count
          this.listLoading = false
        })
      },
      getUserById(userId) {
        getUserById(userId).then(response => {
          const data = response.data
          data.user.mobile = data.user.mobile || data.user.loginId
          this.dialogForm = data.user
        })
      },
      addUser() {
        addUser(this.dialogForm).then(response => {
          const data = response.data
          if(data) {
            this.dialogVisible = false
            this.$message({
              message: '创建成功',
              type: 'success',
              showClose: true,
              duration: 1000
            })
            this.getList()
          }
        })
      },
      updateUser() {
        let data = {
          memberUserId: this.dialogForm.id,
          password: this.dialogForm.password,
          email: this.dialogForm.email
        }
        if (this.dialogForm.trueName) {
          data.trueName = this.dialogForm.trueName
        }
        updateUser(data).then(response => {
          const data = response.data
          if(data) {
            this.dialogVisible = false
            this.$message({
              message: '更新成功',
              type: 'success',
              showClose: true,
              duration: 1000
            })
            this.getList()
          }
        })
      },
      deleteUser(userId) {
        adminDeleteUser(userId).then(response => {
          const data = response.data
          if (data) {
            this.$message({
              message: '删除成功',
              type: 'success',
              showClose: true,
              duration: 1000
            })
            this.getList()
          }
        })
      },
      getMemberShipTypeList() {
        getMemberShipTypeList({status: 0}).then(response => {
          const data = response.data
          this.roleList = data.list.slice(0,5)
        })
      },
      addMembershipTypeToMemberUser() {
        const data = {
          memberUserId: this.dialogTypeForm.id,
          membershipType: this.dialogTypeForm.membershipType
        }
        addMembershipTypeToMemberUser(data).then(response => {
          const data = response.data
          if(data && data) {
            this.dialogTypeVisible = false
            this.$message({
              message: '添加会员身份成功',
              type: 'success',
              showClose: true,
              duration: 1000
            })
            this.getList()
          }
        })
      },
      formatRole: function(row, column) {
        const roleId = row[column.property];
        const role = find(this.roleList, function (item) {
          return item.id == roleId
        });
        return role&&role.title
      },
      formatDate: function(row, column) {
        const date = row[column.property];
        return date && moment(date).format('YYYY-MM-DD HH:mm:ss')
      },
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss">
  .users-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
      th>{
        .cell {
          text-overflow: clip;
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }

    .el-dialog__body .modal .el-input input {
      max-width: 100% !important;
    }

    .el-date-editor.el-input {
      width: 140px;
    }

    .el-input__prefix {
      left: 10px
    }

    .el-input__suffix {
      right: 10px;
    }

    .el-input--prefix .el-input__inner {
      padding-left: 25px;
      padding-right: 20px;
    }
  }
</style>
